import { Link, createFileRoute } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { SectionCard } from '@/components/console/section-card'
import { DetailSkeleton, ErrorState } from '@/components/console/states'
import { PageContainer } from '@/components/layout/page-container'
import { Button } from '@/components/ui/button'
import { apiErrorMessage, isNotFound, useQuoteDetail } from '@/features/quotes/api'
import { QuoteDraftOrderCard } from '@/features/quotes/components/quote-draft-order-card'
import { QuoteItemsTable } from '@/features/quotes/components/quote-items-table'
import { QuoteHeaderCard, QuoteOverviewCard } from '@/features/quotes/components/quote-overview'

export const Route = createFileRoute('/_authed/quotes/$quoteId')({
  component: QuoteDetailPage,
})

function QuoteDetailPage() {
  const { quoteId } = Route.useParams()
  const query = useQuoteDetail(quoteId)
  const quote = query.data

  return (
    <PageContainer
      title={`报价 ${quoteId}`}
      breadcrumbs={[{ label: '报价管理', to: '/quotes' }, { label: quoteId }]}
      actions={
        <Button variant="outline" size="sm" asChild>
          <Link to="/quotes">
            <ArrowLeft className="size-3.5" />
            返回列表
          </Link>
        </Button>
      }
    >
      {query.isLoading ? (
        <DetailSkeleton fields={15} />
      ) : query.isError || !quote ? (
        <ErrorState
          title={isNotFound(query.error) ? `报价 ${quoteId} 不存在或已被移除` : '报价详情加载失败'}
          message={isNotFound(query.error) ? '资源号可能有误,或该报价已被清理。' : apiErrorMessage(query.error)}
          onRetry={() => {
            void query.refetch()
          }}
          action={
            <Button variant="outline" size="sm" asChild>
              <Link to="/quotes">回到报价列表</Link>
            </Button>
          }
        />
      ) : (
        <div className="flex flex-col gap-3">
          <QuoteHeaderCard quote={quote} />
          <QuoteOverviewCard quote={quote} />

          <SectionCard title={`报价行项(${String(quote.items.length)})`} bodyClassName="p-0">
            <QuoteItemsTable items={quote.items} />
          </SectionCard>

          <QuoteDraftOrderCard draftOrder={quote.draft_order} />
        </div>
      )}
    </PageContainer>
  )
}
